import fetch from './../fetch';

const queryCharts = (data) => {
    return fetch.post('zgcp/result/analysis/group/analysis', data)
    .then(res => {
        if(res.code === 200) {
            return {
                dataSource: res.payload.data,
            }
        }
        return {
            dataSource:[],
        }
    })
}

/**
 * 多方汇总分析
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const multiple = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('zyzg/eval/result/analysis/scientific/multiple', Object.assign(defaultsParams, keywords))
}

/**
 * 相关性分析
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const correlationAnalysis = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('zyzg/eval/result/analysis/scientific/correlationAnalysis', Object.assign(defaultsParams, keywords))
}


/**
 * 数据分布分析
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const plotAnalysis = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('zyzg/eval/result/analysis/scientific/plotAnalysis', Object.assign(defaultsParams, keywords))
}

/**
 * 正态数据检验分析
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const normalTest = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('zyzg/eval/result/analysis/scientific/normalTest', Object.assign(defaultsParams, keywords))
}

/**
 * 相关性数据导出
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const exportCorrelation = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.download('zyzg/eval/result/analysis/scientific/exportCorrelation', Object.assign(defaultsParams, keywords), "相关性分析.xls")
}

export default {
    queryCharts,
    multiple,
    correlationAnalysis,
    plotAnalysis,
    normalTest,
    exportCorrelation
}